// For example: /notifications/5f8f14d95c27e817bdead856 or /service/5fd90d064eb2ebeea67ac4fd
export const urlWithHashedId = (url: string): boolean => {
  const pieces = url.split('/');
  const lastPiece: string | undefined = pieces.length > 0 ? pieces[pieces.length - 1] : undefined;
  return lastPiece?.length === 24 && lastPiece.indexOf('-') === -1;
};
